import { RouteConditions } from '@/types/route'

export const conditionsMatch = ({
  userConditions,
  routeConditions
}: {
  userConditions?: RouteConditions
  routeConditions?: RouteConditions
}): boolean => {
  if (!userConditions || !routeConditions) return false

  return Object.keys(routeConditions).every((key) => routeConditions[key] === userConditions[key])
}
